<div class="datatable-header">
  <h3 class="datatable-header__title">
    @if (dynamicTableTitle()) {
      {{ dynamicTableTitle() }}
    } @else {
      {{ datatableConfig()?.title + titleExtension() }}
    }
    @if (datatableConfig()?.select?.showInTitle) {
      <div class="number_of_selection">
        {{ tableSelectionService.selectionSignal()?.length }} selected
      </div>
    }
  </h3>
  <div class="datatable-header__buttons">
    <ng-template [ngTemplateOutlet]="buttons"></ng-template>
    @for (button of computedHeaderButtons(); track button.icon || button.id || $index) {
      @if (button.id === 'search') {
        <table-datatable-search
          (searchFieldEdit)="onSearchFieldEdit($event)"
          [initialShowSearch]="searchConfig()?.expand"
          [(search)]="searchConfig().signal"
        ></table-datatable-search>
      } @else if (isSignal(button.doHide) ? !button.doHide() : !button.doHide) {
        <div
          [matTooltip]="
            button.isDisabled?.()
              ? (isSignal(button.disabledHoverText)
                  ? button.disabledHoverText()
                  : button.disabledHoverText) ||
                (isSignal(button.hoverText) ? button.hoverText() : button.hoverText)
              : isSignal(button.hoverText)
                ? button.hoverText()
                : button.hoverText
          "
        >
          <button
            [class]="{
              'app-card__buttons': true,
              'btn-hover': hoverState() && button.id === 'filter',
            }"
            mat-icon-button
            [id]="button.id || ''"
            [disabled]="button.isDisabled?.()"
            (click)="button.id !== 'more-options' ? button.onClick?.($event) : null"
            [matMenuTriggerFor]="button.id === 'more-options' ? headerMenu : null"
            [color]="button.color ?? 'primary'"
          >
            <mat-icon
              class="datatable-header__icon"
              fontSet="material-symbols-outlined"
              [matBadge]="button.badge"
              [matBadgeHidden]="!button.badge"
              matBadgeColor="accent"
              matBadgeSize="small"
              matBadgePosition="above after"
              aria-hidden="false"
              [svgIcon]="(isSignal(button.svgIcon) ? button.svgIcon() : button.svgIcon) ?? ''"
              [style.color]="button.color ?? 'primary'"
              >{{
                (isSignal(button.svgIcon) ? button.svgIcon() : button.svgIcon) ? '' : button.icon
              }}</mat-icon
            >
          </button>
        </div>
      }
    }
    @if (isLoadingCSV()) {
      <div class="button-spinner">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
    }
  </div>

  <mat-menu #headerMenu="matMenu">
    @for (groupedButton of groupedHeaderButtons(); track groupedButton.id || $index) {
      <button
        mat-menu-item
        (click)="groupedButton.onClick?.($event)"
        [disabled]="groupedButton.isDisabled?.()"
      >
        <mat-icon
          fontSet="material-symbols-outlined"
          [svgIcon]="
            (isSignal(groupedButton.svgIcon) ? groupedButton.svgIcon() : groupedButton.svgIcon) ??
            ''
          "
          >{{
            (isSignal(groupedButton.svgIcon) ? groupedButton.svgIcon() : groupedButton.svgIcon)
              ? ''
              : groupedButton.icon
          }}</mat-icon
        >
        <span>{{
          isSignal(groupedButton.hoverText) ? groupedButton.hoverText() : groupedButton.hoverText
        }}</span>
      </button>
    }
  </mat-menu>
</div>
